import { Stack } from "@mui/material";
import { QuestionnaireQuestion } from "@repo/api";
import { FC, useMemo } from "react";
import { BodyTextM } from "../../Typography";
import * as Styled from "./QuestionnairePage.styled";
import { QuestionnaireQuestionImageComponent } from "./QuestionnaireQuestionImageComponent";
import { QuestionnaireQuestionMultipleChoices } from "./QuestionnaireQuestionMultipleChoices";
import { QuestionnaireQuestionSingleChoice } from "./QuestionnaireQuestionSingleChoice";

export const QuestionnaireQuestionComponent: FC<{
    question: QuestionnaireQuestion;
    questionNumber: number;
}> = ({ question, questionNumber }) => {
    const images = useMemo(() => {
        return (
            question.images?.map((image) => ({
                base64: image.base64,
                legend: image.legend,
                id: crypto.randomUUID(),
            })) ?? []
        );
    }, [question.images]);

    return (
        <Stack key={question.id} id={`question-${question.id}`}>
            <BodyTextM strong>{`${questionNumber}. ${question.text}`}</BodyTextM>

            {images.map((image) => (
                <QuestionnaireQuestionImageComponent key={image.id} image={image} />
            ))}

            <Styled.QuestionnaireQuestionAnswerPaper>
                {question.multipleAllowed === true ? (
                    <QuestionnaireQuestionMultipleChoices question={question} />
                ) : (
                    <QuestionnaireQuestionSingleChoice question={question} />
                )}
            </Styled.QuestionnaireQuestionAnswerPaper>
        </Stack>
    );
};
